import { Tooltip, TooltipPlacement } from 'farmhub-ui-core';
import { ChevronsLeft, ChevronsRight } from 'lucide-react';

import { NameText } from 'components';

import { CollapseButtonWrapper } from './styles';

interface BackMenuProps {
  isToggle: boolean;
  onClick: (e: any) => void;
}

const CollapseButton = ({ isToggle, onClick }: BackMenuProps): JSX.Element => (
  <Tooltip
    placement={TooltipPlacement.Right}
    title={!isToggle && 'Mở rộng danh mục'}
  >
    <CollapseButtonWrapper isToggle={isToggle} onClick={onClick}>
      {isToggle ? (
        <ChevronsLeft size={16} strokeWidth={1.5} />
      ) : (
        <ChevronsRight size={16} strokeWidth={1.5} />
      )}

      {isToggle && (
        <NameText className="text" style={{ marginLeft: 10 }} weight="medium">
          Thu gọn danh mục
        </NameText>
      )}
    </CollapseButtonWrapper>
  </Tooltip>
);

export default CollapseButton;
